export default {
  title: {
    en: 'Thank you',
  },
  text: {
    vindicia: {
      en: 'Your subscription plan has been successfully updated. Your next charge will be ${price}',
    },
    recurly: {
      en: 'Your subscription plan has been successfully updated. Your next charge will be {price}',
    },
  },
  buttonTitle: {
    en: 'Got it',
  },
}
